module.exports = __webpack_public_path__ + "img/PigYearLogo.f4cd1ead.png";